/**
 * Public pages that players, App Review and the stores link to. The server can
 * override privacy and terms through /api/config; these are the fallbacks so the
 * links are always present, including inside the native app.
 */
export const SITE_URL = 'https://skislope.app';
export const PRIVACY_URL = `${SITE_URL}/privacy/`;
export const TERMS_URL = `${SITE_URL}/terms/`;
export const SUPPORT_URL = `${SITE_URL}/support/`;
